

function writeTag(parent, tag, text) {
  const el = parent.ownerDocument.createElementNS('http://tojsoft.net/ARPG', tag);
  el.textContent = text;
  parent.append(el);
}

function writeElement(parent, tag) {
  const el = parent.ownerDocument.createElementNS('http://tojsoft.net/ARPG', tag);
  parent.append(el);
  return el;
}

function addAttribute(el, attr, val) {
  el.setAttributeNS('http://tojsoft.net/ARPG', attr, val);
}

function writeTags(parent, obj, tags) {
  tags.forEach(t => {
    if (obj[t] && obj[t].toString().length > 0)
      writeTag(parent, t, obj[t]);
  });
}

function writeResourceInfo(parent, res) {
  writeTags(parent, res, ['ID', 'Name', 'Icon']);
}

function writeItem(parent, res) {
  writeTags(parent, res, ['Description', 'Type', 'Gold', 'Damage', 'Armor', 'ArmorPenalty', 'Uses', 'OnUse', 'TargetType']);
  writeTag(parent, 'Identified', res.Identified ? 'true' : 'false');
}

function writeCreature(parent, res) {
  writeTags(parent, res, ['Description', 'MaxHP', 'MaxMP',
                          'STR', 'DEX', 'INT',
                          'WTR', 'ERT', 'AIR', 'FIR',
                          'ATK', 'ARC', 'DEF',
                          'LOR', 'THF', 'WOD', 'LUK',
                          'AP', 'XP']);
  writeTag(parent, 'Enemy', res.Enemy ? 'true' : 'false');
  res.Skill.forEach(s => {
    writeTag(parent, 'Skill', s);
  });
  res.Spell.forEach(s => {
    writeTag(parent, 'Spell', s);
  });
  res.Item.forEach(i => {
    writeTag(parent, 'Item', i);
  });
  res.Equipment.forEach(i => {
    const el = writeElement(parent, 'Equipment');
    el.textContent = i.ID;
    addAttribute(el, 'Type', i.Type);
  });
  writeTags(parent, res, ['OnCreate', 'OnCombatRound', 'OnDeath',
                          'OnDamaged', 'OnInteract', 'OnRound', 'OnSee']);
}

function writeMap(parent, res, files) {
  addAttribute(writeElement(parent, 'Tiles'), 'ref', res.ID + '.txt');
  files[res.ID + '.txt'] = res.Tiles;
  writeTag(parent, 'Outdoor', res.Outdoor ? 'true' : 'false');
  writeTags(parent, res, ['OnInteract', 'OnMove']);
  res.Spawn.forEach(s => {
    // save spawns
    const el = writeElement(parent, 'Spawn');
    addAttribute(el, 'x', s.x);
    addAttribute(el, 'y', s.y);
    el.textContent = s.ID;
  });

  res.Trigger.forEach(t => {
    // save triggers
    const el = writeElement(parent, 'Trigger');
    writeTags(el, t, ['X1', 'Y1', 'X2', 'Y2', 'OnInteract', 'OnMove']);
    writeTag(el, 'OnlyPC', t.OnlyPC ? 'true' : 'false');
    writeTag(el, 'OnlyOnce', t.OnlyOnce ? 'true' : 'false');
  });
}

function writeTrap(parent, res) {
  writeTags(parent, res, ['Spot', 'Disarm', 'OnMove']);
}

function writeSkill(parent, res) {
  writeTags(parent, res, ['Description',
                'TargetType',
                'RequiredStat',
                'RequiredValue',
                'Cooldown',
                'OnUse',
                'Gain']);
}

function writeBlueprint(parent, res, files) {
  writeResourceInfo(parent, res);
  switch (res._type) {
    case 'Script':
      writeTag(parent, 'File', res.ID);
      files[res.ID + '.lua'] = res.FileLua;
      break;
    case 'Item':
      writeItem(parent, res);
      break;
    case 'Creature':
      writeCreature(parent, res);
      break;
    case 'Map':
      writeMap(parent, res, files);
      break;
    case 'Trap':
      writeTrap(parent, res);
      break;
    case 'Skill':
      writeSkill(parent, res);
      break;
    default:
      break;
  }
}

export function exportXML(module, ser) {
  const xmlDoc = document.implementation.createDocument("http://tojsoft.net/ARPG", "Module");
  const doc = xmlDoc.documentElement;

  writeResourceInfo(doc, module);
  writeTags(doc, module, ['OnInit', 'OnLoad', 'OnSave']);

  const root = writeElement(doc, 'Blueprints');
  const files = {};
  module.Blueprints.forEach(bp => {
    const bpEl = writeElement(root, bp._type);
    writeBlueprint(bpEl, bp, files);
  });

  const xmlStr = ser.serializeToString(xmlDoc);
  files['module.xml'] = xmlStr;
  return files;
}
